/** Értesités kérése dialog ******************** */
class NotifyDialog {
	/**
	 * NotifyDialog constructor
	 * @param {object} datesJson - a json object that contains all the possible dates
	 * @param {HTMLElement} yearSelect - the year select element
	 * @param {HTMLElement} monthSelect - the month select element
	 * @param {HTMLElement} daySelect - the day select element
	 * @param {HTMLElement} dialog - the dialog element
	 * @param {HTMLElement} closeButton - the close button element
	 */

	/**
	 * Initializes a NotifyDialog instance.
	 * Sets up the select elements for year, month, and day.
	 * Finds the dialog and close button elements in the DOM.
	 * Calls the init method to set up the dialog.
	 *
	 * @param {object} datesJson - A JSON object containing selectable dates.
	 */
	constructor(datesJson) {
		this.datesJson = datesJson;
		this.yearSelect = document.querySelector("#y");
		this.monthSelect = document.querySelector("#m");
		this.daySelect = document.querySelector("#d");
		this.dialog = document.querySelector("dialog[data-mode]");
		this.closeButton = document.querySelector("dialog[data-mode] .dialog-close");

		this.init();
	}

	init() {
		this.fillAllDates();
		this.addEventListeners();
	}

	/**
	 * Populates the year select element with options derived from the datesJson data.
	 * For each year in the datesJson object, an option element is created and appended.
	 * Additionally, fills the month select element for the first year in the list.
	 */
	fillAllDates() {
		const years = Object.keys(this.datesJson);
		this.yearSelect.innerHTML = '';
		years.forEach((year, i) => {
			this.yearSelect.innerHTML += `<option value="${year}">${year}</option>`;
			if (i == 0) {
				this.fillMonths(year);
			}
		});
	}

	/**
	 * Fill the month select element with options
	 * @param {number|string
	 */
	fillMonths(year) {
		this.monthSelect.innerHTML = '';
		const months = this.datesJson[year];
		let i = 0;
		for (const [key, value] of Object.entries(months)) {
			this.monthSelect.innerHTML += `<option value="${value[0]}">${value[1]}</option>`;
			if (i == 0) {
				this.fillDays(value[2], value[3]);
			}
			i++;
		}
	}

	/**
	 * Fill the day select element with options from 'from' to 'to'
	 * @param {number} from - the first day of the month
	 * @param {number} to - the last day of the month
	 */
	fillDays(from, to) {
		this.daySelect.innerHTML = '';
		for (let i = from; i <= to; i++) {
			this.daySelect.innerHTML += `<option value="${i}">${i}</option>`;
		}
	}

	/**
	 * Opens the notification dialog and fills all date options.
	 * This method will display the dialog to the user and populate
	 * the year, month, and day select elements with available options
	 * from the datesJson data.
	 */
	openNotify() {
		this.dialog.showModal();
		this.fillAllDates();
	}

	/**
	 * Adds event listeners to the dialog elements:
	 * - Close button: Close the dialog when clicked
	 * - Year select: Fill the months select when the year is changed
	 * - Month select: Fill the days select when the month is changed
	 */
	addEventListeners() {
		this.closeButton.addEventListener("click", () => {
			this.dialog.close();
		});

		this.yearSelect.addEventListener("change", () => {
			const year = parseInt(this.yearSelect.value);
			this.fillMonths(year);
		});

		this.monthSelect.addEventListener("change", () => {
			const year = parseInt(this.yearSelect.value);
			const month = parseInt(this.monthSelect.value);
			this.fillDays(this.datesJson[year][month][2], this.datesJson[year][month][3]);
		});
	}
}
window.NotifyDialog = NotifyDialog;
